
<div class="col-12 mt-2">
  <div class="col-12 border border-info rounded " #topDiv>
    <div class="col-12 flex" id="topGroup">
      <div class="col-2" style="width: 23%;padding-right: 0px;padding-left: 0px;">
        <div class="flex ui-inputgroup userIdLable" style="margin-top: 10px;width: 95%;" >
          <div style="width:44%">
          <p-dropdown  [style]="{'width':'101%'}"  placeholder="Choose Search" 
          [options]="searchFilterList"  name="searchFilterList" [(ngModel)]="selectedSearchFilter">
          </p-dropdown></div>
          <input pInputText name="SearchSample" [(ngModel)]="valueToSearch" size="17"
          (keydown.enter)="searchForBatchWIthFilter()" style=" border-radius: 1px;width: 47%; height: 33px;" />
      </div>
    </div>
    <div class="col-3" id="multiselectDiv">
      <div class="ui-inputgroup flex" id="filterLabel">
        <button pButton style="height: 33px;margin-top: 4px;" class="w-4 theme-button noHover labelButton" type="button" label="Sender"></button>
        <p-multiSelect [options]="searchSenderList" (onChange)="onApplyFilter($event)" [(ngModel)]="valueToSearchforSender"
          id="multiselectStatuses" [style]="{'width':'200px','margin-top': '3px','height': '35px'}">
          <ng-template let-item pTemplate="selectedItem">
            <span style="vertical-align:middle">{{item.label}}</span>
          </ng-template>
          <ng-template let-status pTemplate="item">
            {{status.label}}
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="col-3 ui-inputgroup" style="margin-top: 12px;">
      <button pButton class="theme-button noHover labelButton h-2rem" type="button" label="Status"></button>
      <p-dropdown [style]="{'width':'229px'}" placeholder="Select Status" 
        [options]="searchstatusList" name="customertList" 
        [(ngModel)]="valueToSearchforStatus" (onChange)="changeStatus()" [panelStyle]="{maxHeight: '250px', overflowY: 'auto'}">
      </p-dropdown>
    </div>
  <div class=" col-1 ui-inputgroup userIdLable">
      <button pButton class="p-2 border-round" icon="fa fa-search" label="Search" (click)="getAllTableData()" ></button></div>
  <div class=" col-1 ui-inputgroup userIdLable">
      <button pButton class="p-2 border-round" icon="fa fa-remove" (click)="clearTableData()" label="Clear"></button></div>
  <div class=" col-1 ui-inputgroup userIdLable">
    <button pButton class="p-2 border-round" icon="fa fa-download" label="Excel" [disabled]="!(setRowdataforExport && setRowdataforExport.length != 0)" (click)="exportToExcelCheck()"></button></div>
  </div>
  <div class="col-12 flex">
    <div class="col-3"></div>
    <div class="col-3" style="margin-left: -1%;">
      <input type="checkbox" [(ngModel)]="isSelected" (change)="getinvoicedbatches($event.target.checked)">  includes invoiced batches
    </div>
    <div class="col-6 flex" style="margin-left: -1%;" id="datePicker">
        <div class="col-2 p-0 mr-3" style="width: 21%;">
          <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter($event)"
            [inputStyle]="{'width':'70%'}" [dateFormat]="dateFormat" [showIcon]="true" placeholder="From"
            showButtonBar="true" (onClearClick)="onApplyFilter($event)" (onTodayClick)="onApplyFilter($event)"
            [maxDate]="toDate" [disabled]="statusDisabled"></p-calendar>
        </div>
        <div class="col-2 p-0" style="margin-left: 0%;width: 20%;">
          <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter($event)"
            [inputStyle]="{'width':'70%'}" [dateFormat]="dateFormat" [showIcon]="true" placeholder="To"
            showButtonBar="true" (onClearClick)="onApplyFilter($event)" (onTodayClick)="onApplyFilter($event)" [disabled]="statusDisabled"></p-calendar>
        </div>
      </div>
    </div>

   
    </div>
  </div>
  <div class="col-12 flex"   [style.height.px]="divHeight">
    <p-table #dt [value]="populateTableData" [columns]="scrollableCols"  [scrollHeight]="scrollHeight" (onRowSelect)="addToSelectedRows($event)" (onRowUnselect)="removeFromSelectedMap($event)" selectionMode="multiple" class="overflow-hidden" [(selection)]="selectedRows"
    (onHeaderCheckboxToggle)="onTableHeaderCheckboxToggle($event)">
      <ng-template pTemplate="caption">
        <div> 
          <p-tableHeaderCheckbox    [disabled]="tableRowSelection == 'none'" ></p-tableHeaderCheckbox><label>Select All Rows</label>
          <span  style="margin-left: 54%;" >
            <em class="fa fa-search" ></em>
            <input type="text" pInputText size="50" placeholder="Global Filter" class="p-1" (input)="dt.filterGlobal($event.target.value, 'contains')">
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr >
        <ng-container *ngFor="let col of columns">
            <th scope="col" *ngIf="col.field == 'statusOfTheBatch'" class="text-center" style="min-width: 15rem;" >
              {{col.header}}
            </th>
            <th scope="col" *ngIf="col.field != 'statusOfTheBatch'" class="text-center" style="min-width: 10rem;" >
              {{col.header}}
            </th>
        </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-batch let-columns="columns">
        <tr [pSelectableRow]="batch">
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field == 'batchID'" style="width: 10rem;height: 2.6rem;" class="text-center">
              <a [routerLink]="['/covid19entryNew', batch.batchID]"  >{{ batch[col.field] }}</a>
            </td>
            <td  *ngIf="col.field != 'batchID'" [ngStyle]="getStyle(col.field)" class="text-center">
              <span *ngIf="(col.field == 'unitPrice' || col.field == 'totalPrice') && batch.statusOfTheBatch=='INVOICED'">{{ getTextCellUnitTotalPrice(col.field, batch) | number: '1.2-2': 'en' }}</span>
              <span *ngIf="col.field != 'unitPrice' && col.field != 'totalPrice'">{{ getTextCellValue(col.field, batch) }}</span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr >
          <td [attr.colspan]="15" class="text-center">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-dialog header="Notification" [(visible)]="notificationOfMoreData" [modal]="true" [dismissableMask]="true">
    <label>Dear User, </label><br>
    Too many batches matches your search query. BlueBerry will show recent 250 batches only.
    Please be more restrictive to see older entries.
  <p-footer>
    <button pButton type="button" label="Ok" (click)="closedialogBox()"></button>
  </p-footer>
</p-dialog>


<p-dialog header="Export Configuration" [(visible)]="customerExport" [modal]="true" [dismissableMask]="true">
  <div class="exportPopUp">
    <p-checkbox id="checkbox" [(ngModel)]="rowDataCheck" [binary]="true" label="batch overview list" labelStyleClass="mb-0">
    </p-checkbox>
  </div>
  <div class="exportPopUp">
    <p-checkbox id="checkbox" [(ngModel)]="senderDataCheck" [binary]="true" label="batch detailed list per sender" labelStyleClass="mb-0">
    </p-checkbox>
  </div>

<p-footer>
  <button pButton type="button" label="Ok" (click)="exportToExcel()"></button>
</p-footer>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>